import { createSlice } from '@reduxjs/toolkit';

import { ClassificationSubgroup } from 'entities/ClassificationSubgroup';
import { AppError } from 'entities/Errors';

import { getClassificationSubgroupList } from './classification_subgroup.action';

interface ClassificationSubgroupState {
  loading: boolean;
  error: null | AppError;
  classificationSubgroups: ClassificationSubgroup[];
}

const initialState = {
  loading: false,
  error: null,
  classificationSubgroups: [],
} as ClassificationSubgroupState;

export const classificationSubgroupSlice = createSlice({
  name: 'classificationSubgroup',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getClassificationSubgroupList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getClassificationSubgroupList.fulfilled, (state, action) => {
        state.loading = false;
        state.classificationSubgroups = action.payload.data;
      })
      .addCase(getClassificationSubgroupList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as AppError;
      });
  },
});

export default classificationSubgroupSlice.reducer;
